import { getUniqueString as e, hasSlotContent as t } from "../../common/utils/index.js";
import { t as n } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import r from "../presence/presence.js";
import { AVATAR_GROUP_VALIDATOR as i, AVATAR_KIND_MODIFIERS as a, AVATAR_PRESENCE_SIZE_MODIFIERS as o, AVATAR_PRESENCE_STATES as s, AVATAR_SIZE_MODIFIERS as c, colorToFamilyVariant as l, computeAvatarHex as u, getRandomFamilyVariant as d } from "./avatar-constants.js";
import { extractInitialsFromName as f } from "./utils.js";
import { createBlock as p, createCommentVNode as m, createElementBlock as h, createElementVNode as g, mergeProps as _, normalizeClass as v, normalizeStyle as y, openBlock as b, renderSlot as x, resolveComponent as S, resolveDynamicComponent as C, toDisplayString as w, withCtx as T } from "vue";
//#region components/avatar/avatar.vue
var E = typeof CSS < "u" && CSS.supports?.("background", "oklch(0.5 0.1 0)"), D = {
	compatConfig: { MODE: 3 },
	name: "DtAvatar",
	components: { DtPresence: r },
	props: {
		id: {
			type: String,
			default() {
				return e();
			}
		},
		seed: {
			type: String,
			default: void 0
		},
		family: {
			type: Number,
			default: void 0,
			validator: (e) => e >= 1 && e <= 12
		},
		variant: {
			type: Number,
			default: void 0,
			validator: (e) => e >= 0 && e < 10
		},
		color: {
			type: String,
			default: void 0
		},
		size: {
			type: [String, Number],
			default: 300,
			validator: (e) => Object.keys(c).includes(String(e))
		},
		avatarClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		canvasClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		iconClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		presence: {
			type: String,
			default: s.NONE,
			validator: (e) => Object.values(s).includes(e)
		},
		presenceProps: {
			type: Object,
			default: () => ({})
		},
		group: {
			type: Number,
			default: void 0,
			validator: (e) => i(e)
		},
		overlayText: {
			type: String,
			default: ""
		},
		overlayClass: {
			type: [
				String,
				Array,
				Object
			],
			default: ""
		},
		imageSrc: {
			type: String,
			default: ""
		},
		imageAlt: {
			type: String,
			default: void 0
		},
		fullName: {
			type: String,
			default: ""
		},
		interactive: {
			type: Boolean,
			default: !1
		},
		clickable: {
			type: Boolean,
			default: null
		},
		iconAriaLabel: {
			type: String,
			default: void 0
		},
		iconOnly: {
			type: Boolean,
			default: !1
		},
		deactivated: {
			type: Boolean,
			default: !1
		}
	},
	emits: ["click"],
	data() {
		return {
			AVATAR_SIZE_MODIFIERS: c,
			AVATAR_KIND_MODIFIERS: a,
			AVATAR_PRESENCE_SIZE_MODIFIERS: o,
			imageLoadedSuccessfully: null,
			formattedInitials: "",
			initializing: !1,
			hasSlotContent: t,
			anchorHue: 0
		};
	},
	computed: {
		resolvedInteractive() {
			return this.clickable ?? this.interactive;
		},
		hasOverlayIcon() {
			return t(this.$slots.overlayIcon);
		},
		isIconType() {
			return t(this.$slots.icon);
		},
		iconDataQa() {
			return "dt-avatar-icon";
		},
		computedFamily() {
			if (!this.isIconType) {
				if (this.family !== void 0) return this.family;
				if (this.color !== void 0) {
					let e = l(this.color);
					if (e) return e.family;
				}
				return d(this.seed).family;
			}
		},
		computedVariant() {
			if (!this.isIconType) {
				if (this.variant !== void 0) return this.variant;
				if (this.color !== void 0) {
					let e = l(this.color);
					if (e) return e.variant;
				}
				return d(this.seed).variant;
			}
		},
		avatarClasses() {
			return [
				"d-avatar",
				c[this.validatedSize],
				this.avatarClass,
				{
					"d-avatar--group": this.showGroup,
					"d-avatar--group-digits-2": this.showGroup && String(this.formattedGroup).length === 2,
					"d-avatar--group-digits-3": this.showGroup && String(this.formattedGroup).length >= 3,
					"d-avatar--clickable": this.resolvedInteractive,
					"d-avatar--presence": this.presence && !this.showGroup,
					"d-avatar--icon-only": this.iconOnly,
					"d-avatar--deactivated": this.deactivated
				}
			];
		},
		avatarStyles() {
			let e = [];
			if (!E && !this.isIconType && this.computedFamily && this.computedVariant !== void 0) {
				let t = u(this.computedFamily, this.computedVariant, this.anchorHue);
				e.push({ "--avatar-color-background": t });
			}
			return e.length > 0 ? e : void 0;
		},
		overlayClasses() {
			return [
				"d-avatar__overlay",
				this.overlayClass,
				{ "d-avatar__overlay-icon": this.hasOverlayIcon }
			];
		},
		showGroup() {
			return i(this.group);
		},
		formattedGroup() {
			let e = String(this.validatedSize);
			return ([
				"xs",
				"100",
				"150",
				"200",
				"250"
			].includes(e) ? 2 : 3) == 2 ? this.group > 9 ? "9+" : this.group : this.group > 99 ? "99+" : this.group;
		},
		validatedSize() {
			return this.size;
		},
		showImage() {
			return this.imageLoadedSuccessfully !== !1 && this.imageSrc;
		}
	},
	watch: {
		fullName: {
			immediate: !0,
			handler() {
				this.formatInitials();
			}
		},
		size: {
			immediate: !0,
			handler() {
				this.formatInitials();
			}
		},
		group: {
			immediate: !0,
			handler() {
				this.formatInitials();
			}
		},
		imageSrc(e) {
			this.imageLoadedSuccessfully = null, e && (this.validateProps(), this.setImageListeners());
		}
	},
	mounted() {
		this.validateProps(), this.setImageListeners(), E || this.readAnchorHue();
	},
	methods: {
		async setImageListeners() {
			await this.$nextTick();
			let e = this.$refs.avatarImage;
			e && (e.addEventListener("load", () => this._loadedImageEventHandler(e), { once: !0 }), e.addEventListener("error", () => this._erroredImageEventHandler(e), { once: !0 }));
		},
		formatInitials() {
			let e = f(this.fullName), t = String(this.validatedSize);
			t === "xs" || t === "100" ? this.formattedInitials = "" : t === "sm" || t === "150" || t === "200" ? this.formattedInitials = e[0] : this.formattedInitials = e;
		},
		readAnchorHue() {
			try {
				let e = getComputedStyle(document.documentElement).getPropertyValue("--dt-avatar-anchor-hue").trim();
				this.anchorHue = parseFloat(e) || 0;
			} catch {
				this.anchorHue = 0;
			}
		},
		_loadedImageEventHandler(e) {
			this.imageLoadedSuccessfully = !0, e.classList.remove("d-d-none");
		},
		_erroredImageEventHandler(e) {
			this.imageLoadedSuccessfully = !1, e.classList.add("d-d-none");
		},
		validateProps() {
			this.imageSrc && this.imageAlt === void 0 && console.error("image-alt required if image-src is provided. Can be set to \"\" (empty string) if the image is described in text nearby");
		},
		handleClick(e) {
			this.resolvedInteractive && this.$emit("click", e);
		}
	}
}, O = { class: "d-avatar__canvas-inner" }, k = ["src", "alt"], A = ["aria-label", "data-qa"], j = {
	key: 1,
	class: "d-avatar__overlay-text"
}, M = ["aria-label"];
function N(e, t, n, r, i, a) {
	let o = S("dt-presence");
	return b(), p(C(a.resolvedInteractive ? "button" : "div"), {
		id: n.id,
		class: v(a.avatarClasses),
		style: y(a.avatarStyles),
		"data-avatar-family": n.iconOnly ? void 0 : a.computedFamily,
		"data-avatar-variant": n.iconOnly ? void 0 : a.computedVariant,
		"data-qa": "dt-avatar",
		type: a.resolvedInteractive ? "button" : void 0,
		onClick: a.handleClick
	}, {
		default: T(() => [
			g("div", {
				ref: "canvas",
				class: v([
					n.canvasClass,
					"d-avatar__canvas",
					{ "d-avatar--image-loaded": i.imageLoadedSuccessfully }
				])
			}, [g("div", O, [a.showImage ? (b(), h("img", {
				key: 0,
				ref: "avatarImage",
				class: "d-avatar__image",
				"data-qa": "dt-avatar-image",
				src: n.imageSrc,
				alt: n.imageAlt
			}, null, 8, k)) : a.isIconType ? (b(), h("div", {
				key: 1,
				class: v([n.iconClass, i.AVATAR_KIND_MODIFIERS.icon]),
				"aria-label": a.resolvedInteractive ? n.iconAriaLabel : "",
				"data-qa": a.iconDataQa
			}, [x(e.$slots, "icon")], 10, A)) : (b(), h("span", {
				key: 2,
				class: v([i.AVATAR_KIND_MODIFIERS.initials])
			}, w(i.formattedInitials), 3))])], 2),
			a.hasOverlayIcon || n.overlayText ? (b(), h("div", {
				key: 0,
				class: v(a.overlayClasses)
			}, [a.hasOverlayIcon ? x(e.$slots, "overlayIcon", { key: 0 }) : n.overlayText ? (b(), h("p", j, w(n.overlayText), 1)) : m("", !0)], 2)) : m("", !0),
			a.showGroup ? (b(), h("span", {
				key: 1,
				class: "d-avatar__count",
				"data-qa": "dt-avatar-count",
				role: "img",
				"aria-label": `${n.group} participants`
			}, w(a.formattedGroup), 9, M)) : m("", !0),
			n.presence && !a.showGroup && i.AVATAR_PRESENCE_SIZE_MODIFIERS[n.size] ? (b(), p(o, _({
				key: 2,
				presence: n.presence,
				class: ["d-avatar__presence", i.AVATAR_PRESENCE_SIZE_MODIFIERS[n.size]]
			}, n.presenceProps, { "data-qa": "dt-presence" }), null, 16, ["presence", "class"])) : m("", !0)
		]),
		_: 3
	}, 8, [
		"id",
		"class",
		"style",
		"data-avatar-family",
		"data-avatar-variant",
		"type",
		"onClick"
	]);
}
var P = /* @__PURE__ */ n(D, [["render", N]]);
//#endregion
export { P as default };

//# sourceMappingURL=avatar.js.map